<rt-dialog-body variant="white">
  <div padding layout-vertical layout-full-width>
    <div layout layout-justify-center margin-bottom-large>
      @if (imgUrl) {
        <div class="img-wrap">
          <img src="{{ imgUrl }}" />
        </div>
      }
      @if (!!youtubeUrl) {
        <div class="video-wrap">
          <iframe
            width="601"
            height="338"
            [src]="youtubeUrl"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      }
    </div>
    <div class="text-wrap" layout-vertical layout-align-items-center>
      <rt-heading variant="heading large-xx" text-center margin-bottom>
        {{ activeStep.title }}
      </rt-heading>
      <div class="text">
        <div [innerHTML]="activeStep.description" class="description"></div>
        @if (activeStep.articleLinkKey) {
          <div>
            <a [rtHelpArticle]="activeStep.articleLinkKey">
              {{ dialogBodyTranslations.learnMore }}
            </a>
          </div>
        }
      </div>
    </div>
  </div>
</rt-dialog-body>
<div class="footer">
  <div layout padding layout-space-between>
    <rt-button (click)="close(); trackSkipButton()" variant="outline">
      {{ dialogBodyTranslations.skip }}
    </rt-button>
    <rt-tutorial-dialog-nav
      [count]="stepsCount"
      [active]="state.activeStepIndex"
      (select)="setStep($event)"
    >
    </rt-tutorial-dialog-nav>
    @if (!isLast) {
      <rt-button (click)="nextStep()" variant="primary">
        {{
          activeStep.isStep0 ? dialogBodyTranslations.startTour : dialogBodyTranslations.continue
        }}
      </rt-button>
    }
    @if (isLast) {
      <rt-button (click)="close(); trackFinishButton()" variant="primary">
        {{ dialogBodyTranslations.finish }}
      </rt-button>
    }
  </div>
</div>
